





































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Inject } from '@cds/common';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';

@Component({
  components: {}
})
export default class KPIFolderAddPopup extends Vue {
  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;

  @Prop() private folderId!: Number;

  @Watch('folderId', { immediate: true, deep: true })
  public onChangeFolderId(newVal: any, oldVal: any) {
    console.log('folderId watch', newVal)
    const isEdit = typeof newVal === 'number';
    this.isEdit = isEdit;
    
    // 先清理表单验证状态
    this.$nextTick(() => {
      const formRef = this.$refs.formRef as any;
      if (formRef) {
        formRef.clearValidate();
      }
    });
    
    if (isEdit) {
      this.fetchFolderDetail();
    } else {
      // 新增模式，重置所有数据
      this.resetForm();
    }
  }

  public isEdit: boolean = false;
  public form: any = {
    id: undefined,
    postLevel: '全部', // 默认面向全部
    name: '', // 目录名称
    sortNumber: undefined, // 排序号，默认不设置
  };

  // 表单验证规则
  public rules: any = {
    postLevel: [
      { required: true, message: '请选择Post Level', trigger: 'change' }
    ],
    name: [
      { required: true, message: '请输入主目录名称', trigger: 'blur' }
    ]
  };

  public async created(): Promise<void> {
  }

  @Emit('saved') // 父级接收事件名
  private async emitSaved(): Promise<void> {
    // return this.xxxxxx; // 父级接收的值
  }

  @Emit('cancel') // 父级接收事件名
  private async emitClose(): Promise<void> {
    // return this.xxxxxx; // 父级接收的值
  }

  // 获取主目录详情
  private async fetchFolderDetail(): Promise<void> {
    this.nuoxiaoerService.fetchKpiFolderDetail({ id: this.folderId }).then(resData => {
      console.log('接口返回', resData);
      this.form = {
        id: resData.id,
        postLevel: resData.postLevel || '全部',
        name: resData.name || '',
        sortNumber: resData.sortNumber || undefined,
      };
    }).catch(err => {
      console.error('获取主目录详情失败：', err);
      this.$message.error('获取主目录详情失败，请刷新重试');
    });
  }

  // 重置表单数据
  private resetForm(): void {
    this.form = {
      id: undefined,
      postLevel: '全部', // 默认面向全部
      name: '', // 目录名称
      sortNumber: undefined, // 排序号，默认不设置
    };
    
    // 清理表单验证状态
    this.$nextTick(() => {
      const formRef = this.$refs.formRef as any;
      if (formRef) {
        formRef.clearValidate();
        formRef.resetFields();
      }
    });
  }

  // 保存表单
  public submitForm(formName: string): void {
    const addRef = (this.$refs.formRef as any);

    addRef.validate(async (valid: boolean) => {
      if (!valid) {
        console.log('表单验证失败');
        return false;
      }
      try {
        // 确认保存
        await this.$confirm('是否确认信息发布？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'info'
        });

        // 准备提交数据
        let submitData: any = {
          id: this.form.id,
          name: this.form.name,
          postLevel: this.form.postLevel,
        };

        // 添加排序号（如果有）
        if (this.form.sortNumber !== undefined && this.form.sortNumber !== null) {
          submitData.sortNumber = this.form.sortNumber;
        }

        // 判断是新增还是编辑模式
        if (this.isEdit) {
          // 编辑模式，添加id字段
          // submitData.id = this.folderId;
          // 使用更新接口
          await this.nuoxiaoerService.updateKpiFolder(submitData);
          this.$message({ message: '更新成功', type: 'success' });
        } else {
          // 新增模式
          await this.nuoxiaoerService.saveKpiFolder(submitData);
          this.$message({ message: '保存成功', type: 'success' });
        }
        this.emitSaved();
      } catch (error) {
        if (error === 'cancel') {
          console.log('取消保存');
          // 用户取消操作，不做处理
          return;
        }
        console.error('保存失败：', error);
        this.$message.error('保存失败：' + (error.message || '未知错误'));
      }
    });
  }

  private async handleCancel(): Promise<void> {
    try {
      await this.$confirm('是否关闭当前界面？关闭后，当前界面内容将会丢失', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      });
      this.emitClose();
    } catch (error) {
      // 用户取消操作，不做处理
    }
  }

}
